var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6181 23.5842H25.9812V11.5934H29.9999L15 0.592285L0 11.5934H4.01876V23.5842H2.38184C1.43298 23.5842 0.661152 24.356 0.661152 25.3048V29.4076H29.3387V25.3048C29.3388 24.356 28.567 23.5842 27.6181 23.5842ZM3.50347 10.4463L15 2.01501L26.4965 10.4463H3.50347ZM24.8341 11.5934V23.5842H21.8182V11.5934H24.8341ZM20.6711 11.5934V23.5842H17.6552V11.5934H20.6711ZM16.5081 11.5934V23.5842H13.4922V11.5934H16.5081ZM12.3451 11.5934V23.5842H9.32889V11.5934H12.3451ZM8.1818 11.5934V23.5842H5.1659V11.5934H8.1818ZM28.1916 28.2605H1.80829V25.3049C1.80829 24.9884 2.06565 24.7313 2.38184 24.7313H27.6181C27.9343 24.7313 28.1916 24.9885 28.1916 25.3049V28.2605Z",
    fill: "#FF6700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 4.67871C13.709 4.67871 12.6582 5.72217 12.6582 7.00428C12.6582 8.28639 13.7089 9.32984 15.0003 9.32984C16.2917 9.32984 17.3424 8.28639 17.3424 7.00428C17.3424 5.72222 16.2916 4.67871 15.0003 4.67871ZM15.0003 8.18276C14.3413 8.18276 13.8053 7.65401 13.8053 7.00428C13.8053 6.35454 14.3414 5.8258 15.0003 5.8258C15.6593 5.8258 16.1953 6.35454 16.1953 7.00428C16.1953 7.65401 15.6593 8.18276 15.0003 8.18276Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.9aed32f295818b446d99a769f36b71d3.svg";
export { ForwardRef as ReactComponent };